import { BrowserRouter, Routes, Route } from "react-router-dom";

import Home from "./pages/Home";
import LiveDetection from "./pages/LiveDetection";
import HowItWorks from "./pages/HowItWorks";
import Research from "./pages/Research";
import Team from "./pages/Team";
import Accessibility from "./pages/Accessibility";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />} />

        <Route path="/live" element={<LiveDetection />} />

        <Route path="/how" element={<HowItWorks />} />

        <Route path="/research" element={<Research />} />

        <Route path="/team" element={<Team />} />

        <Route path="/accessibility" element={<Accessibility />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
